import { useTripDesignerConfig } from '../config/TripDesignerConfigProvider';
import { isDayEditable } from '../logic/ownership';

/**
 * Whether the current app may edit a given day, per `useTripDesignerConfig().isOwnProduct`.
 * With the default predicate (`() => true`) every day is editable — TO's
 * behaviour, since it has no ownership concept.
 */
export function useIsDayEditable(
  day: any,
  experiencesMap: Record<string, any> | undefined,
): boolean {
  const { isOwnProduct } = useTripDesignerConfig();
  return isDayEditable(day, experiencesMap, isOwnProduct);
}
